'use client';

import { FC } from 'react';
import FadeIn from '@/components/FadeIn/FadeIn';
import { usePostHog } from 'posthog-js/react';

interface ProductCTAFooterProps {
  title: string;
  subtitle?: string;
  ctaLabel?: string;
  ctaHref?: string;
  productName?: string;
}

const ProductCTAFooter: FC<ProductCTAFooterProps> = ({
  title = 'Smarter sales. Faster results.',
  subtitle = 'Powered by marketbetter',
  ctaLabel = 'Book Demo',
  ctaHref = '/book-demo',
  productName,
}) => {
  const posthog = usePostHog();

  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: '#04216B' }}>
      <div className="container-fluid px-4 md:px-8 xl:px-25 mx-auto" style={{ maxWidth: '1400px' }}>
        <FadeIn variant="up" delay={0.1}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-8">
            {/* Text */}
            <div>
              <h2
                className="text-white font-medium"
                style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2.5rem)', lineHeight: '1.3' }}
              >
                {title}
              </h2>
              {subtitle && (
                <p
                  className="text-white opacity-80 mt-2"
                  style={{ fontSize: 'clamp(1.125rem, 1.5vw, 1.5rem)' }}
                >
                  {subtitle}
                </p>
              )}
            </div>

            {/* CTA Button */}
            <a
              href={ctaHref}
              {...(ctaHref.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
              className="px-8 py-3 bg-white rounded-xl font-medium transition-all duration-300 hover:shadow-lg whitespace-nowrap"
              style={{
                color: '#094FFE',
                fontSize: 'clamp(0.9375rem, 1.125vw, 1.125rem)',
              }}
              onClick={() => productName && posthog?.capture('product_cta_clicked', { product_name: productName, cta_position: 'footer' })}
            >
              {ctaLabel}
            </a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default ProductCTAFooter;
